module.exports = __webpack_public_path__ + "static/media/t13.8d0bb7a5.jpg";